import { ChangeDetectionStrategy, Component, input, model, ViewEncapsulation, computed } from '@angular/core';
import { ITodoListEditItem } from '@fi-app/fi-onboarding/fi-todo/fi-todo';
import { IOnboardingCompletionUserStep } from '../../fi-onboarding-completion';
import { FiOnboardingCompletionStateType } from '../../fi-onboarding-completion-enums';

@Component({
    selector: 'fi-todo-list-completion',
    templateUrl: './todo-list-completion.component.html',
    styleUrl: './todo-list-completion.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-todo-list-completion' },
    standalone: false,
})
export class FiTodoListCompletionComponent {
    public todoList = input.required<ITodoListEditItem>();
    public userCompletionStep = model.required<IOnboardingCompletionUserStep>();
    public nextStepCompletionState = input.required<FiOnboardingCompletionStateType>();

    protected totalTodoItemsCount = computed(() =>
        this.todoList().Sections.reduce((total, section) => total + section.Items.length, 0),
    );
    protected completedTodoItems = computed(() =>
        this.userCompletionStep()?.TodoItemCompletions?.filter((item) => item.IsCompleted),
    );
}
